(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.smHeroReady) return;
      root.dataset.smHeroReady = 'true';

      var shopifySection = root.closest('.shopify-section') || root;
      var sticky = root.querySelector('[data-sm-sticky]');

      function buyButton() {
        return root.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
      }

      /* Variant change (theme event): refresh gallery and sticky bar from the re-rendered page. */
      shopifySection.addEventListener('variant:update', function (event) {
        var html = event.detail && event.detail.data && event.detail.data.html;
        if (!html) return;
        var fresh = html.getElementById(root.id);
        if (!fresh) return;

        var gallery = root.querySelector('[data-sm-gallery]');
        var freshGallery = fresh.querySelector('[data-sm-gallery]');
        if (gallery && freshGallery && gallery.innerHTML !== freshGallery.innerHTML) {
          gallery.innerHTML = freshGallery.innerHTML;
          gallery.scrollLeft = 0;
        }

        var info = root.querySelector('[data-sm-sticky-info]');
        var freshInfo = fresh.querySelector('[data-sm-sticky-info]');
        if (info && freshInfo) info.innerHTML = freshInfo.innerHTML;

        var cta = root.querySelector('[data-sm-sticky-cta]');
        var freshCta = fresh.querySelector('[data-sm-sticky-cta]');
        if (cta && freshCta) {
          cta.disabled = freshCta.disabled;
          cta.textContent = freshCta.textContent;
        }
      });

      if (!sticky) return;

      /* Sticky bar: submits the same theme form (cart drawer and Kaching keep working). */
      var stickyCta = sticky.querySelector('[data-sm-sticky-cta]');
      stickyCta.addEventListener('click', function () {
        var button = buyButton();
        if (button && !button.disabled) button.click();
      });

      /* Show the bar once the main buy button has scrolled above the viewport. */
      var target = root.querySelector('[data-sm-buy]');
      if (!target || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var above = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', above);
      });
      observer.observe(target);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-sm-hero]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Add-on buttons: add one item to the cart natively, then let the theme refresh and open its cart drawer. */
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-sm-addon]');
      if (!button) return;
      var root = button.closest('[data-sm-offer]');
      var row = button.closest('.sm-offer__addon');
      var status = row && row.querySelector('[data-sm-addon-status]');
      var url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || root.getAttribute('data-cart-add-url');
      var sectionIds = [];
      var cartSections = document.querySelectorAll('cart-items-component[data-section-id]');
      for (var i = 0; i < cartSections.length; i++) sectionIds.push(cartSections[i].getAttribute('data-section-id'));

      var body = { items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }] };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      button.disabled = true;
      if (status) status.textContent = '';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw data;
            return data;
          });
        })
        .then(function (data) {
          if (status) status.textContent = root.getAttribute('data-added-label') || '';
          var cartEvent = new Event('cart:update', { bubbles: true });
          cartEvent.detail = {
            resource: data,
            sourceId: button.getAttribute('data-variant-id'),
            data: {
              source: 'sm-offer',
              itemCount: 1,
              productId: button.getAttribute('data-product-id'),
              sections: data.sections,
            },
          };
          button.dispatchEvent(cartEvent);
        })
        .catch(function () {
          if (status) status.textContent = root.getAttribute('data-error-label') || '';
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-tokens"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
      Converts merchant-typed amounts (main store currency) to the visitor's currency.
      Markup: <span data-sm-amount="75">75 USD</span> (the text is the no-JS fallback).
      Uses Shopify Markets' active rate; rounds up to a whole unit when converted.
    */
    function format(value, currency) {
      var whole = value % 1 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2,
        }).format(value);
      } catch (e) {
        return null;
      }
    }

    function convert(root) {
      var current = (window.Shopify && window.Shopify.currency) || {};
      var currency = current.active;
      var rate = parseFloat(current.rate) || 1;
      if (!currency) return;
      var nodes = (root || document).querySelectorAll('[data-sm-amount]');
      for (var i = 0; i < nodes.length; i++) {
        var base = parseFloat(nodes[i].getAttribute('data-sm-amount'));
        if (isNaN(base)) continue;
        var value = rate === 1 ? base : Math.ceil(base * rate);
        var text = format(value, currency);
        if (text) nodes[i].textContent = text;
      }
    }

    /*
      Links with data-sm-scroll-to scroll smoothly to the buy box and put focus on the current
      choice (Kaching bundle, else selected variant, else the buy button). Without JS they are plain #anchors.
    */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-sm-scroll-to]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('data-sm-scroll-to'));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* Kaching hides its radios and uses focusable deal bars ([tabindex]) instead. */
      function focusable(el) {
        if (!el) return null;
        if (el.getClientRects().length && el.tabIndex >= 0) return el;
        return el.closest('[tabindex]:not([tabindex="-1"])');
      }
      var focusTarget =
        focusable(target.querySelector('kaching-bundle input[type="radio"]:checked')) ||
        target.querySelector('kaching-bundle [tabindex]:not([tabindex="-1"])') ||
        focusable(target.querySelector('variant-picker input:checked')) ||
        target.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
      var scrollTarget = (focusTarget && focusTarget.closest('kaching-bundle, variant-picker, [data-sm-buy]')) || target;
      scrollTarget.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if (focusTarget) {
        window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      }
      if (history.replaceState) history.replaceState(null, '', '#' + target.id);
    });

    window.smConvertAmounts = convert;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { convert(); });
    } else {
      convert();
    }
    document.addEventListener('shopify:section:load', function (event) { convert(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-peek-carousel"] && !Shopify.designMode) return;
  try {
    
  function initVideoPeekCarousel(root) {
    const track = root.querySelector('[data-vpc-track]');
    const dotsWrapper = root.closest('.video-peek-carousel-wrapper')?.querySelector('[data-vpc-dots]');
    const dots = dotsWrapper ? Array.from(dotsWrapper.querySelectorAll('[data-vpc-dot]')) : [];
    const items = Array.from(root.querySelectorAll('[data-vpc-item]'));

    if (!track || items.length === 0) return;

    const updateActiveDot = () => {
      if (!dots.length) return;
      const trackRect = track.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
    };

    track.addEventListener('scroll', updateActiveDot, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const item = items[index];
        if (item) {
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  document.querySelectorAll('[data-video-peek-carousel]').forEach(initVideoPeekCarousel);

  } catch(e) { console.error(e); }
})();
})();
